import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "src/app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";
import { FormsModule } from "@angular/forms";
import { CluLockscreenComponent } from "./clu-lockscreen.component";
import { CluNumpadDialogModule } from "../clu-numpad-dialog/clu-numpad-dialog.module";
import { CluLockscreenAccountPickerDialog } from "./@modals/clu-lockscreen-account-picker-dialog/clu-lockscreen-account-picker-dialog.component";
import { CluLockscreenService } from "./clu-lockscreen.service";
import { CluConfirmDialogModule } from "../clu-confirm-dialog/clu-confirm-dialog.module";

@NgModule({
    declarations: [CluLockscreenComponent, CluLockscreenAccountPickerDialog],
    imports: [
        CommonModule,
        TranslateModule,
        MaterialModule,
        TablerIconsModule,
        FormsModule,
        CluNumpadDialogModule,
        CluConfirmDialogModule,
    ],
    exports: [CluLockscreenComponent],
    providers: [CluLockscreenService]
})
export class CluLockscreenModule {}